import { IndexTable, Text } from '@shopify/polaris';

const TransferStockTable = ({ product, transfer }) => {
  const headings = [{ title: '' }, ...product.variants.map((v) => ({ title: v.title })), { title: 'TOTAL' }] || [];
  const rowMarkup = [];

  const depositoOrigen = () =>
    rowMarkup.push({
      title: 'Depósito origen',
      stock: product.variants.map(({ barcode }) => {
        const stock = product.stock.find((s) => s.barcode === barcode);
        return stock && stock.qty
          ? `${stock.originDepositExistsBefore} -> ${stock.originDepositExistsAfter}`
          : stock.originDepositExistsBefore;
      }),
      total: product.stock.reduce((acc, cur) => acc + cur.qty, 0)
        ? `${product.stock.reduce((acc, cur) => acc + cur.originDepositExistsBefore, 0)} -> ${product.stock.reduce(
            (acc, cur) => acc + cur.originDepositExistsAfter,
            0,
          )}`
        : 0,
      deposit: true,
    });
  const depositoDestino = () =>
    rowMarkup.push({
      title: 'Depósito destino',
      stock: product.variants.map(({ barcode }) => {
        const stock = product.stock.find((s) => s.barcode === barcode);
        return stock && stock.qty
          ? `${stock.destinationDepositExistsBefore} -> ${stock.destinationDepositExistsAfter}`
          : stock.destinationDepositExistsBefore;
      }),
      total: product.stock.reduce((acc, cur) => acc + cur.qty, 0)
        ? `${product.stock.reduce((acc, cur) => acc + cur.destinationDepositExistsBefore, 0)} -> ${product.stock.reduce(
            (acc, cur) => acc + cur.destinationDepositExistsAfter,
            0,
          )}`
        : 0,
      deposit: true,
    });

  if (transfer.status === 'PENDING') {
    depositoOrigen();
    rowMarkup.push({
      title: 'Pendiente de envío',
      stock: product.variants.map(({ barcode }) => {
        const stock = product.stock.find((s) => s.barcode === barcode);
        return stock ? stock.qty : 0;
      }),
      total: product.stock.reduce((acc, cur) => acc + cur.qty, 0),
    });
    depositoDestino();
  }

  if (transfer.status === 'IN_TRANSIT' || transfer.status === 'CLOSED') {
    rowMarkup.push(
      {
        title: 'Enviado',
        stock: product.variants
          .map(({ barcode }) => {
            const stock = product.stock.find((s) => s.barcode === barcode);
            return stock ? stock.sentQty : 0;
          })
          .map((d) => (d === 0 ? '' : d.toString().startsWith('-') ? `(${Math.abs(d)})` : d)),
        total: product.stock.reduce((acc, cur) => acc + cur.sentQty, 0),
      },
      {
        title: 'Recibido',
        stock: product.variants
          .map(({ barcode }) => {
            const stock = product.stock.find((s) => s.barcode === barcode);
            return stock ? stock.receivedQty : 0;
          })
          .map((d) => (d === 0 ? '' : d.toString().startsWith('-') ? `(${Math.abs(d)})` : d)),
        total: product.stock.reduce((acc, cur) => acc + cur.receivedQty, 0),
      },
    );

    // Lo que el cierre dio por extraviado. Solo se pinta si lo hay, para no meter una fila
    // vacía en los traspasos normales.
    if (product.stock.some((s) => (s.lostQty ?? 0) > 0)) {
      rowMarkup.push({
        title: 'Extraviado',
        stock: product.variants
          .map(({ barcode }) => {
            const stock = product.stock.find((s) => s.barcode === barcode);
            return stock ? stock.lostQty ?? 0 : 0;
          })
          .map((d) => (d === 0 ? '' : d.toString().startsWith('-') ? `(${Math.abs(d)})` : d)),
        total: product.stock.reduce((acc, cur) => acc + (cur.lostQty ?? 0), 0),
      });
    }

    // Lo que no es ni recibido ni extraviado: sigue sin repartir en la cuenta 210. En un
    // traspaso bien cerrado esto es siempre 0.
    const diferencias = {
      title: 'Diferencias',
      stock: product.variants
        .map(({ barcode }) => {
          const stock = product.stock.find((s) => s.barcode === barcode);
          return stock ? stock.sentQty - stock.receivedQty - (stock.lostQty ?? 0) : 0;
        })
        .map((d) => (d === 0 ? '' : d.toString().startsWith('-') ? `(${Math.abs(d)})` : d)),
      total: product.stock.reduce((acc, cur) => acc + (cur.sentQty - cur.receivedQty - (cur.lostQty ?? 0)), 0),
    };

    rowMarkup.push(diferencias);
  }

  return (
    <IndexTable headings={headings} itemCount={rowMarkup.length} selectable={false} lastColumnSticky={true}>
      {rowMarkup.map((row, index) => (
        <IndexTable.Row id={index} key={index} position={index} subdued selected={false}>
          <IndexTable.Cell>
            <Text alignment="start" variant="headingXs" fontWeight="bold">
              {row.title}
            </Text>
          </IndexTable.Cell>
          {row.stock.map((cell, i) => (
            <IndexTable.Cell key={i}>
              <Text
                alignment={i ? 'center' : 'start'}
                variant="headingXs"
                fontWeight={!(i % row.length) || !((i + 1) % row.length) ? 'bold' : 'regular'}
              >
                {cell}
              </Text>
            </IndexTable.Cell>
          ))}
          <IndexTable.Cell>
            <Text alignment="center" fontWeight="bold" variant="headingXs">
              {row.total}
            </Text>
          </IndexTable.Cell>
        </IndexTable.Row>
      ))}
    </IndexTable>
  );
};

export default TransferStockTable;
